import { render, staticRenderFns } from "./notification-model.vue?vue&type=template&id=a3138696&scoped=true&"
import script from "./notification-model.vue?vue&type=script&lang=js&"
export * from "./notification-model.vue?vue&type=script&lang=js&"
import style0 from "./notification-model.vue?vue&type=style&index=0&id=a3138696&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3138696",
  null
  
)

component.options.__file = "notification-model.vue"
export default component.exports